import React from 'react';

interface MessageTimestampProps {
    createdAt?: Date | number | string;
}

export const MessageTimestamp = React.memo(({ createdAt }: MessageTimestampProps) => {
    // Skip rendering if no createdAt value
    if (!createdAt) {
        return null;
    }

    try {
        const date = new Date(createdAt);
        const formattedTime = date.toLocaleTimeString('ko-KR', {
            hour: '2-digit',
            minute: '2-digit',
        });

        return (
            <time
                dateTime={date.toISOString()}
                className="block px-1 text-xs text-muted-foreground"
                aria-label={`Message sent at ${formattedTime}`}
            >
                {formattedTime}
            </time>
        );
    } catch (error) {
        console.error('Error formatting time:', error);
        return null;
    }
});

MessageTimestamp.displayName = 'MessageTimestamp';
